import { render, staticRenderFns } from "./IhaIssue.vue?vue&type=template&id=58260464&scoped=true&"
import script from "./IhaIssue.vue?vue&type=script&lang=js&"
export * from "./IhaIssue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58260464",
  null
  
)

export default component.exports